import React, { useEffect, useRef } from 'react'

export default function useInterval(callback: () => void, delay:number) {
    const savedCallback = useRef<()=>void>();

    //remember the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback])

    //set up the interval
    useEffect(() => {
        function tick() {
            savedCallback.current && savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [callback, delay])
}
